import { observer } from 'mobx-react-lite'
import React, { useContext } from 'react'
import { SharedCampaignContext } from '../../../../../contexts/Advertiser/SharedCampaignContext'
import InfluencerItem from './Influencers/InfluencerItem'

export default observer(function Influencers({ campaignScenario }) {
  const { influencers } = useContext(SharedCampaignContext)


  const influencerVisibilityMap = new Map()

  // Check each influencer's visibility in this campaign scenario
  influencers.forEach(influencer => {
    const influencerActionGroups = campaignScenario.campaign_scenario_action_groups.filter(
      actionGroup => actionGroup.influencer_id === influencer.id
    )

    // If no action groups exist, default to visible
    if (influencerActionGroups.length === 0) {
      influencerVisibilityMap.set(influencer.id, true)
    } else {
      // If any action group is visible, the influencer is visible
      const isVisible = influencerActionGroups.some(actionGroup => actionGroup.visible_in_budget)
      influencerVisibilityMap.set(influencer.id, isVisible)
    }
  })

  const showInfluencers = influencers.filter(influencer => influencerVisibilityMap.get(influencer.id))
  // const hiddenInfluencers = influencers.filter(influencer => !influencerVisibilityMap.get(influencer.id))


  return (
    <div>
      {
        showInfluencers.map((influencer) => {
          const hasActions = campaignScenario.actions.some(action => action.influencer_id === influencer.id)

          return hasActions ? (
            <InfluencerItem key={influencer.id} influencer={influencer} campaignScenario={campaignScenario} />
          ) : null
        })
      }
    </div>
  )
})